/**
 * is color light or dark
 * @param hexColor - Hex color code (#RRGGBB)
 * @returns If color is light, returns false, if dark returns true
 */
export function isColorDark(hexColor: string | null | undefined): boolean {
  // If color is not defined, consider it as light
  if (!hexColor) return false;

  // Remove # character
  const hex = hexColor.replace('#', '');

  // Invalid hex color code, consider it as light
  if (!/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)) return false;

  // Convert 3 character hex code to 6 character
  const fullHex =
    hex.length === 3
      ? hex
          .split('')
          .map(char => char + char)
          .join('')
      : hex;

  // Calculate RGB values
  const r = parseInt(fullHex.substring(0, 2), 16);
  const g = parseInt(fullHex.substring(2, 4), 16);
  const b = parseInt(fullHex.substring(4, 6), 16);

  // Calculate brightness (YIQ formula)
  // YIQ = (R * 299 + G * 587 + B * 114) / 1000
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is less than 128, color is dark
  return brightness <= 128;
}

// Hex to rgb convert width alpha
export function hexToRgba(hex: string, alpha = 1): string {
  if (alpha < 0 || alpha > 1) {
    alpha = 1;
  }
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return hex;

  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
